
    import Vue from "vue";

    const END_POINT = "/appointment-type";

    const getAppointmentType = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllAppointmentTypes = data => Vue.axios.get(END_POINT, {params: data});

    const createAppointmentType = appointmentType => Vue.axios.post(END_POINT,  appointmentType );

    const createAllAppointmentTypes = AppointmentTypes => Vue.axios.post(END_POINT + "/all",  AppointmentTypes );

    const updateAppointmentType = appointmentType => Vue.axios.put(END_POINT  + "/" + appointmentType.id,  appointmentType );

    const deleteAppointmentType = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getAppointmentType,
      getAllAppointmentTypes,
      createAppointmentType,
      createAllAppointmentTypes,
      updateAppointmentType,
      deleteAppointmentType
    };
    